import React, { memo } from 'react';

import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import * as S from './style';

interface IProps {
  /** text */
  text?: string;
  /** 로고 이미지. URL(문자열)과 노드(svg 컴포넌트) 둘 다 받는다.
   *  지정 시 text 대신 노출되고 text는 aria-label로만 쓰인다 */
  imgSrc?: React.ReactNode;
  /** 활성 시 노출할 이미지. 없으면 imgSrc를 그대로 쓴다 */
  activeImgSrc?: React.ReactNode;
  /** active */
  active?: boolean;
  /** 텍스트 컬러. 선택 전에만 적용되고 active 시에는 #fff로 고정된다 */
  textColor?: string;
  /** disabled */
  disabled?: boolean;
  /** className */
  className?: string;
  /** onClick */
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const FilterChipBtn = ({
  text = '',
  imgSrc,
  activeImgSrc,
  active,
  textColor,
  disabled,
  className,
  onClick,
}: IProps) => {
  const cName = classNameBind([
    'filter-chip-btn item',
    active ? 'active' : '',
    className || '',
  ]);

  // on/off 이미지는 GNB(MainGnbMenuBarItem)와 같은 규칙을 따른다.
  // 활성용이 없으면 기본을 그대로 쓴다.
  const currentImgSrc = active && activeImgSrc ? activeImgSrc : imgSrc;

  // 이미지 > 텍스트 순으로 노출한다. 이미지가 문자열이면 URL로 본다.
  const renderContent = () => {
    if (typeof currentImgSrc === 'string') {
      return (
        <span className="area-logo type-image">
          <img className="img" src={currentImgSrc} alt={text} />
        </span>
      );
    }

    if (currentImgSrc) {
      return <span className="area-logo">{currentImgSrc}</span>;
    }

    return (
      <Text ellipsis={1} maxWidth={175}>
        {text}
      </Text>
    );
  };

  return (
    <S.FilterChipBtn className={cName} $textColor={textColor}>
      <Button label={text} disabled={disabled} onClick={onClick}>
        {renderContent()}
      </Button>
    </S.FilterChipBtn>
  );
};

export default memo(FilterChipBtn);
